(function () {
  const INSTANCE_KEY = '__airtangBuildPackInstances';
  const instances = (window[INSTANCE_KEY] = window[INSTANCE_KEY] || new WeakMap());

  class BuildYourPack {
    constructor(root) {
      this.root = root;
      this.settings = this.parseSettings();
      this.minimumFlavors = Math.max(1, Number(this.settings.minFlavorCount || 3));
      this.moneyFormat = this.settings.moneyFormat || '${{amount}}';
      this.currencyCode = this.settings.currencyCode || 'USD';
      this.strings = this.settings.strings || {};
      this.baseDevicePrice = Number(root.dataset.baseDevicePrice || 0);
      this.selectedDeviceVariantId = null;
      this.packMode = '3';
      this.isSubmitting = false;
      this.flavorQtyByVariantId = Object.create(null);
      this.activeFlavorIndex = 0;
      this.modalOpener = null;
      this.modalIsClosing = false;
      this.modalCloseTimer = null;
      this.modalCloseDuration = 220;
      this.prefersReducedMotionQuery =
        typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

      this.cacheElements();
      this.setStepOpen(this.flavorStep, false);
      this.applyFlavorCardImages();
      this.bindEvents();
      this.bindSideHintMotion();
      this.render();
      this.ensureInitialLockedStepState();
    }

    parseSettings() {
      const node = this.root.querySelector('[data-build-pack-settings]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        console.error('Build-your-pack settings parse error', error);
        return {};
      }
    }

    parseHandleList(rawValue) {
      return String(rawValue || '')
        .split(',')
        .map((item) => item.trim().toLowerCase())
        .filter(Boolean);
    }

    cacheElements() {
      this.errorNode = this.root.querySelector('[data-build-pack-error]');
      this.deviceCards = Array.from(this.root.querySelectorAll('[data-device-card]'));
      this.flavorCards = Array.from(this.root.querySelectorAll('[data-flavor-card]'));
      this.summaryDevice = this.root.querySelector('[data-summary-device]');
      this.summaryFlavors = this.root.querySelector('[data-summary-flavors]');
      this.summaryPack = this.root.querySelector('[data-summary-pack]');
      this.summaryPriceInline = this.root.querySelector('[data-summary-price-inline]');
      this.summaryCompareTotal = this.root.querySelector('[data-summary-compare-total]');
      this.summaryDiscountRow = this.root.querySelector('[data-summary-discount-row]');
      this.summaryDiscount = this.root.querySelector('[data-summary-discount]');
      this.summaryTotal = this.root.querySelector('[data-summary-total]');
      this.submitButton = this.root.querySelector('[data-action="submit-builder"]');
      this.packToggle = this.root.querySelector('.build-pack__pack-toggle');
      this.packButtons = Array.from(this.root.querySelectorAll('[data-action="set-pack-mode"]'));
      this.customPackLabel = this.root.querySelector('[data-pack-custom]');
      this.stepDotDevice = this.root.querySelector('[data-step-dot="device"]');
      this.stepDotFlavors = this.root.querySelector('[data-step-dot="flavors"]');
      this.deviceStep = this.root.querySelector('[data-step="device"]');
      this.flavorStep = this.root.querySelector('[data-step="flavors"]');
      this.flavorStepWrap = this.root.querySelector('.build-pack__flavor-step-wrap');
      this.flavorSideHint = this.root.querySelector('.build-pack__flavor-side-hint');
      this.deviceStepSummary = this.root.querySelector('[data-step-summary="device"]');
      this.flavorStepSummary = this.root.querySelector('[data-step-summary="flavors"]');

      const modalId = `BuildYourPackFlavorModal-${this.root.dataset.sectionId || ''}`;
      this.modal = document.getElementById(modalId) || this.root.querySelector('.build-pack-modal');
      const modalScope = this.modal || this.root;
      this.modalContent = modalScope.querySelector('.build-pack-modal__content');
      this.modalBody = modalScope.querySelector('[data-modal-body]');
      this.modalImage = modalScope.querySelector('[data-modal-image]');
      this.modalTitle = modalScope.querySelector('[data-modal-title]');
      this.modalNotes = modalScope.querySelector('[data-modal-notes]');
      this.modalCloseButton = modalScope.querySelector('[id^="ModalClose-"]');
      this.modalMetricSavoury = modalScope.querySelector('[data-modal-metric="savoury"]');
      this.modalMetricThroat = modalScope.querySelector('[data-modal-metric="throat"]');
      this.modalMetricSweetness = modalScope.querySelector('[data-modal-metric="sweetness"]');
    }

    applyFlavorCardImages() {
      this.flavorCards.forEach((card) => {
        const selectedImage = String(card.dataset.image || '').trim();
        if (!selectedImage) return;

        const images = Array.from(card.querySelectorAll('.card__media .media img'));
        if (!images.length) return;

        images.forEach((imageNode) => {
          imageNode.src = selectedImage;
          imageNode.removeAttribute('srcset');
          imageNode.removeAttribute('sizes');
          if (!imageNode.alt) {
            imageNode.alt = String(card.dataset.title || '');
          }
        });
      });
    }

    bindEvents() {
      const clickHandler = (event) => {
        const flavorLink = event.target.closest('[data-flavor-card] .build-pack__product-card a');
        if (flavorLink && this.root.contains(flavorLink)) {
          event.preventDefault();
          const card = flavorLink.closest('[data-flavor-card]');
          if (card) {
            const opener = card.querySelector('[data-action="open-flavor-modal"]') || card;
            this.onOpenFlavorModal(opener);
          }
          return;
        }

        const actionNode = event.target.closest('[data-action]');
        if (!actionNode) return;
        this.handleAction(actionNode);
      };

      this.root.addEventListener('click', clickHandler);
      if (this.modal) {
        this.modal.addEventListener('click', clickHandler);
        this.bindModalMotionHandlers();
      }

      this.root.addEventListener('click', (event) => {
        const summary = event.target.closest('[data-step-summary]');
        if (!summary || !this.root.contains(summary)) return;
        if (summary.dataset.stepSummary !== 'flavors') return;
        if (this.selectedDeviceVariantId) return;
        event.preventDefault();
        this.setError(this.strings.chooseDeviceFirst || 'Please select a device first.');
        this.pulseStep(this.deviceStep);
      });

      if (this.flavorStep) {
        this.flavorStep.addEventListener('toggle', () => {
          this.updateSideHintPosition();
        });
      }
    }

    bindSideHintMotion() {
      if (!this.flavorSideHint || !this.flavorStepWrap) return;

      const computedTop = Number.parseFloat(window.getComputedStyle(this.flavorSideHint).top);
      this.sideHintBaseTopPx = Number.isFinite(computedTop) ? computedTop : 0;

      const onReposition = () => {
        this.updateSideHintPosition();
      };

      window.addEventListener('scroll', onReposition, { passive: true });
      window.addEventListener('resize', onReposition);
      this.updateSideHintPosition();
    }

    updateSideHintPosition() {
      if (!this.flavorSideHint || !this.flavorStepWrap || !this.flavorStep) return;

      const desktopQuery = window.matchMedia('(min-width: 990px)');
      if (!desktopQuery.matches) {
        this.flavorSideHint.style.removeProperty('top');
        return;
      }

      if (!this.flavorStep.hasAttribute('open')) {
        this.flavorSideHint.style.removeProperty('top');
        return;
      }

      const wrapRect = this.flavorStepWrap.getBoundingClientRect();
      const wrapTopDoc = wrapRect.top + window.scrollY;
      const wrapHeight = this.flavorStepWrap.offsetHeight;
      const hintHeight = this.flavorSideHint.offsetHeight || 0;
      const minTop = Number.isFinite(this.sideHintBaseTopPx) ? this.sideHintBaseTopPx : 0;
      const maxTop = Math.max(minTop, wrapHeight - hintHeight - 16);
      const preferredViewportOffset = 120;
      const desiredTop = window.scrollY + preferredViewportOffset - wrapTopDoc;
      const clampedTop = Math.max(minTop, Math.min(maxTop, desiredTop));

      this.flavorSideHint.style.top = `${Math.round(clampedTop)}px`;
    }

    ensureInitialLockedStepState() {
      if (this.selectedDeviceVariantId) return;
      const enforceClosedFlavorStep = () => {
        if (!this.root || !this.root.isConnected) return;
        if (this.selectedDeviceVariantId) return;
        this.setStepOpen(this.flavorStep, false);
      };

      // Browsers can restore <details open> after initial render on refresh.
      window.requestAnimationFrame(enforceClosedFlavorStep);
      window.setTimeout(enforceClosedFlavorStep, 0);
    }

    handleAction(actionNode) {
      const action = actionNode.dataset.action;
      if (action === 'select-device') {
        this.onSelectDevice(actionNode);
        return;
      }

      if (action === 'set-pack-mode') {
        this.onSetPackMode(actionNode.dataset.packMode);
        return;
      }

      if (action === 'open-flavor-modal') {
        this.onOpenFlavorModal(actionNode);
        return;
      }

      if (action === 'select-flavor') {
        this.onSelectFlavor(actionNode.dataset.variantId);
        return;
      }

      if (action === 'increase-flavor') {
        this.changeFlavorQty(actionNode.dataset.variantId, 1);
        return;
      }

      if (action === 'decrease-flavor') {
        this.changeFlavorQty(actionNode.dataset.variantId, -1);
        return;
      }

      if (action === 'submit-builder') {
        this.onSubmit();
        return;
      }

      if (action === 'modal-prev') {
        this.shiftModalFlavor(-1);
        return;
      }

      if (action === 'modal-next') {
        this.shiftModalFlavor(1);
      }
    }

    onSelectDevice(button) {
      if (button.disabled || button.closest('[data-device-card]')?.dataset.available !== 'true') return;
      this.clearError();
      this.selectedDeviceVariantId = String(button.dataset.variantId || '');
      this.transitionToFlavorStep();
      this.render();
    }

    onSetPackMode(packMode) {
      if (packMode !== '3' && packMode !== '6' && packMode !== 'full') return;

      if (packMode === 'full') {
        this.applyFullPackSelection();
        this.packMode = 'full';
        this.render();
        return;
      }

      const targetCount = Number(packMode);
      this.applyTargetPackSelection(targetCount);

      this.packMode = packMode;
      this.render();
    }

    onOpenFlavorModal(button) {
      const card = button.closest('[data-flavor-card]');
      if (!card || !this.modal) return;
      const index = Number(card.dataset.flavorIndex || 0);
      this.activeFlavorIndex = Number.isNaN(index) ? 0 : index;
      this.modalOpener = button;
      this.modal.classList.remove('is-closing');
      if (this.modalCloseTimer) {
        window.clearTimeout(this.modalCloseTimer);
        this.modalCloseTimer = null;
      }
      this.modalIsClosing = false;
      this.updateModal();
      if (typeof this.modal.show === 'function') {
        this.modal.show(button);
      }
    }

    onSelectFlavor(variantId) {
      if (!this.ensureDeviceSelected()) return;
      if (!variantId) return;
      if (this.isFlavorLimitReached()) {
        this.setError(this.strings.invalidFlavorSelection || 'Select exactly 3, 6, or all flavors.');
        return;
      }
      this.flavorQtyByVariantId[variantId] = 1;
      this.onFlavorQuantityChanged();
    }

    changeFlavorQty(variantId, delta) {
      if (!this.ensureDeviceSelected()) return;
      if (!variantId) return;
      if (delta > 0 && this.isFlavorLimitReached()) {
        this.setError(this.strings.invalidFlavorSelection || 'Select exactly 3, 6, or all flavors.');
        return;
      }
      const current = Number(this.flavorQtyByVariantId[variantId] || 0);
      const next = Math.max(0, current + delta);
      if (next === 0) {
        delete this.flavorQtyByVariantId[variantId];
      } else {
        this.flavorQtyByVariantId[variantId] = next;
      }
      this.onFlavorQuantityChanged();
    }

    onFlavorQuantityChanged() {
      this.clearError();
      const count = this.getFlavorCount();

      if (this.shouldUseFullPackMode(count)) {
        this.packMode = 'full';
      } else if (count >= 4) {
        this.packMode = '6';
      } else if (count >= 1) {
        this.packMode = '3';
      } else {
        this.packMode = '3';
      }
      this.render();
    }
    getFlavorCount() {
      return Object.values(this.flavorQtyByVariantId).reduce((acc, value) => acc + Number(value || 0), 0);
    }

    getFlavorCardByVariantId(variantId) {
      const needle = String(variantId || '');
      if (!needle) return null;
      return this.flavorCards.find((card) => String(card.dataset.variantId || '') === needle) || null;
    }

    isFullBundleMode() {
      return false;
    }

    getCompletePackCount() {
      return this.flavorCards.length > 6 ? this.flavorCards.length : 0;
    }

    getMaxFlavorCount() {
      return this.getCompletePackCount() || 6;
    }

    isFlavorLimitReached() {
      return this.getFlavorCount() >= this.getMaxFlavorCount();
    }

    shouldUseFullPackMode(flavorCount) {
      const completeCount = this.getCompletePackCount();
      if (!completeCount) return false;
      const totalCount = Number(flavorCount || 0);
      return totalCount > 6;
    }

    isCompleteSelection(flavorCount) {
      const completeCount = this.getCompletePackCount();
      if (!completeCount) return false;
      const totalCount = Number(flavorCount || 0);
      return totalCount === completeCount;
    }

    isValidFlavorCount(flavorCount) {
      const count = Number(flavorCount || 0);
      if (count === 3 || count === 6) return true;
      return this.isCompleteSelection(count);
    }

    trimFlavorCount(targetCount) {
      const next = Object.create(null);
      let remaining = Math.max(0, Number(targetCount || 0));

      this.flavorCards.forEach((card) => {
        const variantId = String(card.dataset.variantId || '');
        if (!variantId || remaining <= 0) return;
        const qty = Number(this.flavorQtyByVariantId[variantId] || 0);
        if (qty < 1) return;
        const keep = Math.min(qty, remaining);
        if (keep > 0) {
          next[variantId] = keep;
          remaining -= keep;
        }
      });

      this.flavorQtyByVariantId = next;
    }

    applyTargetPackSelection(targetCount) {
      const target = Math.max(0, Number(targetCount || 0));
      this.trimFlavorCount(target);

      let remaining = Math.max(0, target - this.getFlavorCount());
      if (!remaining) return;

      this.flavorCards.forEach((card) => {
        if (remaining <= 0) return;
        const variantId = String(card.dataset.variantId || '');
        if (!variantId || this.flavorQtyByVariantId[variantId]) return;
        this.flavorQtyByVariantId[variantId] = 1;
        remaining -= 1;
      });
    }

    applyFullPackSelection() {
      const completeCount = this.getCompletePackCount();
      if (!completeCount) return;

      const next = Object.create(null);
      this.flavorCards.forEach((card) => {
        const variantId = String(card.dataset.variantId || '');
        if (!variantId) return;
        next[variantId] = 1;
      });
      this.flavorQtyByVariantId = next;
    }

    getDevicePrice() {
      if (!this.selectedDeviceVariantId) return 0;
      const card = this.getSelectedDeviceCard();
      return card ? Number(card.dataset.price || 0) : 0;
    }

    getSelectedDeviceCard() {
      if (!this.selectedDeviceVariantId) return null;
      return this.deviceCards.find((card) => String(card.dataset.variantId || '') === this.selectedDeviceVariantId) || null;
    }

    getRegularUnitPrice(priceCents, compareAtCents) {
      const price = Math.max(0, Number(priceCents || 0));
      const compareAt = Math.max(0, Number(compareAtCents || 0));
      return compareAt > price ? compareAt : price;
    }

    getCardRegularUnitPrice(card) {
      if (!card) return 0;
      return this.getRegularUnitPrice(card.dataset.price, card.dataset.compareAt);
    }

    getDeviceRegularPrice() {
      const card = this.getSelectedDeviceCard();
      if (!card) return 0;
      return this.getCardRegularUnitPrice(card);
    }

    getFlavorSubtotal() {
      return this.flavorCards.reduce((total, card) => {
        const variantId = String(card.dataset.variantId || '');
        if (!variantId) return total;
        const qty = Number(this.flavorQtyByVariantId[variantId] || 0);
        if (!qty) return total;
        return total + qty * Number(card.dataset.price || 0);
      }, 0);
    }

    getFlavorRegularSubtotal() {
      return this.flavorCards.reduce((total, card) => {
        const variantId = String(card.dataset.variantId || '');
        if (!variantId) return total;
        const qty = Number(this.flavorQtyByVariantId[variantId] || 0);
        if (!qty) return total;
        return total + qty * this.getCardRegularUnitPrice(card);
      }, 0);
    }

    getPreviewDiscountPercent(flavorCount) {
      const count = Number(flavorCount || 0);
      if (this.shouldUseFullPackMode(count)) {
        return Math.max(0, Number(this.settings.fullPackPreviewDiscountPercent || 0));
      }
      if (count >= 4) {
        return Math.max(0, Number(this.settings.sixPackPreviewDiscountPercent || 0));
      }
      return 0;
    }

    getPreviewFlavorSubtotal(flavorSubtotal, flavorCount, flavorRegularSubtotal = 0) {
      const subtotal = Math.max(0, Number(flavorSubtotal || 0));
      const regularSubtotal = Math.max(subtotal, Number(flavorRegularSubtotal || 0));
      const count = Number(flavorCount || 0);
      const isFullPackPreview = this.isCompleteSelection(count);
      const discountBase = isFullPackPreview ? regularSubtotal : subtotal;
      const discountPercent = Math.min(100, this.getPreviewDiscountPercent(count));
      if (!discountPercent) return subtotal;
      return Math.max(0, discountBase - Math.round((discountBase * discountPercent) / 100));
    }

    getBundleRegularSubtotal() {
      return 0;
    }

    ensureDeviceSelected() {
      if (this.selectedDeviceVariantId) {
        if (this.getSelectedDeviceCard()?.dataset.available === 'true') return true;
        this.setError(this.strings.soldOut || 'Sold out');
        return false;
      }
      this.setError(this.strings.chooseDeviceFirst || 'Please select a device first.');
      return false;
    }

    async onSubmit() {
      if (this.isSubmitting) return;
      this.clearError();
      if (!this.ensureDeviceSelected()) return;

      const flavorCount = this.getFlavorCount();
      if (!this.isValidFlavorCount(flavorCount)) {
        this.setError(
          this.strings.invalidFlavorSelection ||
          'Select exactly 3, 6, or all flavors.'
        );
        return;
      }

      const items = [];
      items.push({
        id: Number(this.selectedDeviceVariantId),
        quantity: 1,
        properties: {
          _builder: 'build-your-pack',
        },
      });

      this.flavorCards.forEach((card) => {
        const variantId = String(card.dataset.variantId || '');
        if (!variantId) return;
        const qty = Number(this.flavorQtyByVariantId[variantId] || 0);
        if (qty < 1) return;
        items.push({
          id: Number(variantId),
          quantity: qty,
          properties: {
            _builder: 'build-your-pack',
          },
        });
      });

      if (items.length < 2) {
        this.setError(this.strings.invalidFlavorSelection || 'Select exactly 3, 6, or all flavors.');
        return;
      }

      const invalidItem = items.find((item) => !Number.isFinite(item.id) || item.id <= 0 || !Number.isFinite(item.quantity) || item.quantity < 1);
      if (invalidItem) {
        this.setError(this.strings.errorFallback || 'Could not add to cart.');
        return;
      }

      this.isSubmitting = true;
      this.render();

      const cartTarget = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const payload = { items };
      if (cartTarget && typeof cartTarget.getSectionsToRender === 'function') {
        payload.sections = cartTarget
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',');
        payload.sections_url = window.location.pathname;
        if (typeof cartTarget.setActiveElement === 'function') {
          cartTarget.setActiveElement(this.submitButton);
        }
      }

      try {
        const globalRoutes =
          (typeof window !== 'undefined' && window.routes && typeof window.routes === 'object' && window.routes) ||
          (typeof routes !== 'undefined' && routes && typeof routes === 'object' ? routes : null);
        const route = globalRoutes && globalRoutes.cart_add_url ? globalRoutes.cart_add_url : '/cart/add';
        const routeParts = String(route || '/cart/add').split('?');
        let routePath = (routeParts[0] || '/cart/add').replace(/\/+$/, '');
        const routeQuery = routeParts[1] ? `?${routeParts[1]}` : '';
        try {
          const parsedRoute = new URL(routePath, window.location.origin);
          routePath = parsedRoute.pathname.replace(/\/+$/, '');
        } catch (error) {
          // Keep best-effort relative path if URL parsing fails.
        }
        const endpoint = routePath.endsWith('.js') ? `${routePath}${routeQuery}` : `${routePath}.js${routeQuery}`;
        const root =
          (window.Shopify &&
            window.Shopify.routes &&
            typeof window.Shopify.routes.root === 'string' &&
            window.Shopify.routes.root) ||
          '/';
        const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
        const fallbackEndpoint = `${normalizedRoot}cart/add.js`;
        const config = this.getFetchConfig();
        config.method = config.method || 'POST';
        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers.Accept = 'application/json';
        config.headers['Content-Type'] = 'application/json';
        config.credentials = 'same-origin';
        config.body = JSON.stringify(payload);

        let response = await fetch(endpoint, config);
        if (response.status === 401 && fallbackEndpoint !== endpoint) {
          response = await fetch(fallbackEndpoint, config);
        }
        let parsed = {};
        const raw = await response.text();
        if (raw) {
          try {
            parsed = JSON.parse(raw);
          } catch (parseError) {
            if (!response.ok) {
              throw new Error(`Unable to add pack (${response.status || 'error'}).`);
            }
          }
        }

        if (!response.ok || parsed.status) {
          const fallbackMessage = `Unable to add pack (${response.status || 'error'}).`;
          throw new Error(
            parsed.description || parsed.message || this.strings.errorFallback || fallbackMessage
          );
        }

        let renderedCartUi = false;
        if (cartTarget && typeof cartTarget.renderContents === 'function') {
          this.clearCartEmptyState(cartTarget);
          const sectionsFromAdd = this.hasRenderableSections(parsed.sections, cartTarget) ? parsed.sections : null;
          renderedCartUi = this.renderCartTarget(cartTarget, parsed, sectionsFromAdd);

          if (!renderedCartUi) {
            const fetchedSections = await this.fetchCartDrawerSections(cartTarget);
            renderedCartUi = this.renderCartTarget(cartTarget, parsed, fetchedSections);
          }
        }

        if (renderedCartUi) {
          return;
        }

        if (globalRoutes && globalRoutes.cart_url) {
          window.location.href = globalRoutes.cart_url;
          return;
        } else {
          window.location.href = '/cart';
          return;
        }
      } catch (error) {
        this.setError(error.message || this.strings.errorFallback || 'Could not add to cart.');
      } finally {
        this.isSubmitting = false;
        this.render();
      }
    }
    async fetchCartDrawerSections(cartTarget) {
      if (!cartTarget || typeof cartTarget.getSectionsToRender !== 'function') return null;

      const sectionsToRender = cartTarget
        .getSectionsToRender()
        .filter((section) => section && section.id)
        .map((section) => section.id);

      if (!sectionsToRender.length) return null;

      const sectionsUrl = new URL(window.location.pathname || '/', window.location.origin);
      sectionsUrl.searchParams.set('sections', sectionsToRender.join(','));
      const sectionMap = {};

      try {
        const response = await fetch(sectionsUrl.toString(), {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
          },
        });
        if (response.ok) {
          const raw = await response.text();
          if (raw) {
            let parsed = null;
            try {
              parsed = JSON.parse(raw);
            } catch (error) {
              parsed = null;
            }
            if (parsed && typeof parsed === 'object') {
              sectionsToRender.forEach((sectionId) => {
                const html = parsed[sectionId];
                if (typeof html === 'string' && html.trim()) {
                  sectionMap[sectionId] = html;
                }
              });
            }
          }
        }
      } catch (error) {
        // Fallback below.
      }

      if (Object.keys(sectionMap).length !== sectionsToRender.length) {
        await Promise.all(
          sectionsToRender.map(async (sectionId) => {
            if (sectionMap[sectionId]) return;
            try {
              const url = new URL(window.location.pathname || '/', window.location.origin);
              url.searchParams.set('section_id', sectionId);
              const response = await fetch(url.toString(), {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                },
              });
              if (!response.ok) return;
              const html = await response.text();
              if (!html) return;
              sectionMap[sectionId] = html;
            } catch (error) {
              // Ignore section-level errors and allow fallback redirect.
            }
          })
        );
      }

      return Object.keys(sectionMap).length ? sectionMap : null;
    }

    clearCartEmptyState(cartTarget) {
      if (!cartTarget) return;
      if (cartTarget.classList && cartTarget.classList.contains('is-empty')) {
        cartTarget.classList.remove('is-empty');
      }
      if (cartTarget.tagName && cartTarget.tagName.toLowerCase() === 'cart-drawer') {
        const drawerItems = cartTarget.querySelector('cart-drawer-items.is-empty');
        if (drawerItems) drawerItems.classList.remove('is-empty');
      }
    }

    renderCartTarget(cartTarget, parsedState, sections) {
      if (!cartTarget || typeof cartTarget.renderContents !== 'function') return false;
      if (!this.hasRenderableSections(sections, cartTarget)) return false;

      try {
        cartTarget.renderContents({ ...parsedState, sections });
        this.clearCartEmptyState(cartTarget);
        return true;
      } catch (error) {
        return false;
      }
    }

    hasRenderableSections(sectionMap, cartTarget) {
      if (!sectionMap || typeof sectionMap !== 'object' || !cartTarget) return false;
      if (typeof cartTarget.getSectionsToRender !== 'function') return false;

      const sections = cartTarget.getSectionsToRender();
      if (!Array.isArray(sections) || !sections.length) return false;

      return sections.every((section) => {
        if (!section || !section.id) return false;
        const html = sectionMap[section.id];
        if (typeof html !== 'string' || !html.trim()) return false;
        const selector = section.selector || '.shopify-section';

        try {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return !!doc.querySelector(selector);
        } catch (error) {
          return false;
        }
      });
    }

    shiftModalFlavor(direction) {
      if (!this.flavorCards.length) return;
      this.activeFlavorIndex = (this.activeFlavorIndex + direction + this.flavorCards.length) % this.flavorCards.length;
      this.updateModal({ animate: true, direction });
    }

    updateModal(options = {}) {
      if (!this.modalBody || !this.flavorCards.length) return;
      const card = this.flavorCards[this.activeFlavorIndex];
      if (!card) return;

      const title = card.dataset.title || '';
      const modalTitle = this.normalizeModalTitle(title);
      const image = card.dataset.image || '';
      const notes = card.dataset.notes || '';
      const sentence = String(card.dataset.sentence || '')
        .replace(/\s+/g, ' ')
        .trim();
      const bg = this.safeColor(card.dataset.modalBg, '#eaf2f0');
      const text = this.safeColor(card.dataset.modalText, '#2f6f47');
      const accent = this.safeColor(card.dataset.modalAccent, '#3b6a2b');
      const savoury = this.toDotValue(card.dataset.savoury);
      const throat = this.toDotValue(card.dataset.throat);
      const sweetness = this.toDotValue(card.dataset.sweetness);
      const parsedNotes = this.parseModalNotes(notes, sentence);

      const modalThemeNode = this.modalContent || this.modalBody;
      if (modalThemeNode) {
        modalThemeNode.style.background = bg;
        modalThemeNode.style.setProperty('--flavor-bg', bg);
        modalThemeNode.style.setProperty('--flavor-text', text);
        modalThemeNode.style.setProperty('--flavor-accent', accent);
      }
      if (this.modalTitle) this.modalTitle.textContent = modalTitle;
      this.modalImage.hidden = !image;
      this.modalImage.src = image;
      this.modalImage.alt = modalTitle || title;
      if (this.modalNotes) {
        const sentenceText = sentence.replace(/\s*\.\.\.\s*$/g, '').trim();
        this.modalNotes.textContent = sentenceText || parsedNotes.description;
      }

      this.renderMetricDots(this.modalMetricSavoury, savoury);
      this.renderMetricDots(this.modalMetricThroat, throat);
      this.renderMetricDots(this.modalMetricSweetness, sweetness);

      if (options.animate) {
        this.animateModalFlavorChange(Number(options.direction || 0));
      }
    }

    bindModalMotionHandlers() {
      if (!this.modal) return;
      if (this.prefersReducedMotionQuery && this.prefersReducedMotionQuery.matches) return;

      const requestAnimatedClose = (event) => {
        if (!this.modal.hasAttribute('open')) return false;

        if (event) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
        }

        if (this.modalIsClosing) return true;

        this.modalIsClosing = true;
        this.modal.classList.add('is-closing');

        if (this.modalCloseTimer) {
          window.clearTimeout(this.modalCloseTimer);
        }

        this.modalCloseTimer = window.setTimeout(() => {
          this.modalCloseTimer = null;
          this.modalIsClosing = false;
          this.modal.classList.remove('is-closing');
          if (typeof this.modal.hide === 'function') {
            this.modal.hide();
          }
        }, this.modalCloseDuration);

        return true;
      };

      if (this.modalCloseButton) {
        this.modalCloseButton.addEventListener(
          'click',
          (event) => {
            requestAnimatedClose(event);
          },
          true
        );
      }

      this.modal.addEventListener(
        'click',
        (event) => {
          if (event.target === this.modal) {
            requestAnimatedClose(event);
          }
        },
        true
      );

      this.modal.addEventListener(
        'keyup',
        (event) => {
          if (event.code && event.code.toUpperCase() === 'ESCAPE') {
            requestAnimatedClose(event);
          }
        },
        true
      );
    }

    animateModalFlavorChange(direction = 0) {
      if (!this.modalBody || !this.modal || !this.modal.hasAttribute('open')) return;
      if (this.prefersReducedMotionQuery && this.prefersReducedMotionQuery.matches) return;
      if (typeof this.modalBody.animate !== 'function') return;

      const xOffset = direction < 0 ? -16 : direction > 0 ? 16 : 0;
      this.modalBody.animate(
        [
          { opacity: 0, transform: `translate3d(${xOffset}px, 0, 0)` },
          { opacity: 1, transform: 'translate3d(0, 0, 0)' },
        ],
        {
          duration: 240,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        }
      );
    }

    safeColor(value, fallback) {
      const input = String(value || '').trim();
      if (!input) return fallback;
      if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') {
        return CSS.supports('color', input) ? input : fallback;
      }
      return input;
    }

    parseModalNotes(rawNotes, preferredDescription = '') {
      const clean = String(rawNotes || '')
        .replace(/\s+/g, ' ')
        .trim();
      const cleanPreferred = String(preferredDescription || '')
        .replace(/\s+/g, ' ')
        .replace(/\s*\.\.\.\s*$/g, '')
        .trim();

      const descriptionSource = cleanPreferred || clean;
      let description = '';
      if (descriptionSource) {
        const sentenceParts = descriptionSource
          .split(/(?<=[.!?])\s+/)
          .map((part) => part.trim())
          .filter(Boolean);
        const primarySentence = sentenceParts[0] || descriptionSource;
        const secondarySentence = sentenceParts[1] || '';
        description = primarySentence;
        if (!cleanPreferred && description.length < 52 && secondarySentence) {
          description = `${description} ${secondarySentence}`;
        }
        if (description.length > 130) {
          description = `${description.slice(0, 130).trim()}...`;
        }
      }

      let tags = '';
      if (clean) {
        const maybeTagPrefix = clean.match(/^(?:notes?|flavo[u]?r notes?)\s*[:\-]\s*(.+)$/i);
        const tagSource = (maybeTagPrefix && maybeTagPrefix[1]) || clean;
        const primaryTagSlice = tagSource
          .split(/[.!?]/)[0]
          .replace(/\s*\.\.\.\s*$/g, '')
          .trim();
        const commaParts = primaryTagSlice
          .split(',')
          .map((part) => part.trim())
          .filter(Boolean);

        if (commaParts.length >= 2 && commaParts[0].length <= 24 && commaParts[1].length <= 24) {
          tags = `${commaParts[0]}, ${commaParts[1]}`;
        } else if (primaryTagSlice.includes(' - ')) {
          const [left, right] = primaryTagSlice.split(' - ').map((part) => part.trim());
          if (left && right && left.length <= 22 && right.length <= 22) {
            tags = `${left}, ${right}`;
          }
        }
      }

      if (tags.length > 44) {
        tags = `${tags.slice(0, 44).trim()}...`;
      }

      return { tags, description };
    }

    normalizeModalTitle(rawTitle) {
      const title = String(rawTitle || '').trim();
      if (!title) return '';
      return title
        .replace(/\(([^)]*)\)/g, '')
        .replace(/\b(flavo[u]?r|core|pack|coils?)\b/gi, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
    }

    renderMetricDots(node, value) {
      if (!node) return;
      const clamped = Math.max(0, Math.min(3, Number(value || 0)));
      node.innerHTML = '';
      for (let i = 1; i <= 3; i += 1) {
        const dot = document.createElement('span');
        dot.className = `build-pack-modal__dot${i <= clamped ? ' is-active' : ''}`;
        node.appendChild(dot);
      }
    }

    toDotValue(raw) {
      const value = Number(raw || 0);
      if (Number.isNaN(value)) return 0;
      return Math.max(0, Math.min(3, value));
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, this.moneyFormat);
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: this.currencyCode,
      }).format(cents / 100);
    }

    formatMoneyForDeviceButton(cents) {
      const amount = Number(cents || 0) / 100;
      try {
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.currencyCode,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
        const parts = formatter.formatToParts(amount);
        const currency = parts.find((part) => part.type === 'currency')?.value || this.currencyCode;
        const number = parts
          .filter((part) => part.type !== 'currency' && part.type !== 'literal')
          .map((part) => part.value)
          .join('');
        return `${currency}${number}`;
      } catch (error) {
        return this.formatMoney(cents);
      }
    }
    getFetchConfig() {
      if (typeof fetchConfig === 'function') {
        return fetchConfig('json');
      }
      return {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      };
    }

    formatFraction(current, target) {
      const template = this.strings.fractionTemplate || '[current]/[target]';
      return template.replace('[current]', String(current)).replace('[target]', String(target));
    }

    getNextThreshold(flavorCount, fullCount) {
      const count = Number(flavorCount || 0);
      if (count < 3) return 3;
      if (count > 3 && count < 6) return 6;
      if (count > 6 && fullCount > 0 && count < fullCount) return fullCount;
      return null;
    }

    setStepOpen(step, shouldOpen) {
      if (!step) return;
      if (shouldOpen) {
        step.setAttribute('open', '');
      } else {
        step.removeAttribute('open');
      }
    }

    pulseStep(step) {
      if (!step) return;
      step.classList.remove('is-focus-step');
      window.requestAnimationFrame(() => {
        step.classList.add('is-focus-step');
        window.setTimeout(() => {
          step.classList.remove('is-focus-step');
        }, 900);
      });
    }

    smoothScrollToElement(element, duration = 900, offset = 12) {
      if (!element) return;
      const startY = window.scrollY || window.pageYOffset || 0;
      const targetY = Math.max(0, element.getBoundingClientRect().top + startY - offset);
      const delta = targetY - startY;
      if (Math.abs(delta) < 2) return;

      const startTime = performance.now();
      const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

      const tick = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        const eased = easeInOutCubic(progress);
        window.scrollTo(0, startY + delta * eased);
        if (progress < 1) {
          window.requestAnimationFrame(tick);
        }
      };

      window.requestAnimationFrame(tick);
    }

    transitionToFlavorStep() {
      if (!this.selectedDeviceVariantId) return;
      this.setStepOpen(this.deviceStep, false);
      this.setStepOpen(this.flavorStep, true);
      this.pulseStep(this.flavorStep);
      if (this.flavorStepSummary) {
        this.smoothScrollToElement(this.flavorStepSummary, 950, 14);
      }
    }

    renderPackOnly(flavorCount) {
      this.packButtons.forEach((button) => {
        const active = button.dataset.packMode === this.packMode;
        button.classList.toggle('is-active', active);
      });
      if (this.summaryPack) {
        const customSummaryLabel = this.customPackLabel?.dataset?.packSummaryLabel?.trim();
        const customLabel = customSummaryLabel || this.customPackLabel?.textContent?.trim();
        if (this.isCompleteSelection(flavorCount) && customLabel) {
          this.summaryPack.textContent = customLabel;
          return;
        }
        const selectedPackButton = this.root.querySelector(`[data-pack-mode="${this.packMode}"]`);
        const selectedPackLabel = selectedPackButton?.dataset?.packSummaryLabel?.trim();
        this.summaryPack.textContent =
          selectedPackLabel ||
          (this.packMode === '6'
            ? selectedPackButton?.textContent?.trim() || '6 Pack'
            : selectedPackButton?.textContent?.trim() || '3 Pack');
      }
    }

    render() {
      const flavorCount = this.getFlavorCount();
      const devicePrice = this.getDevicePrice();
      const rawFlavorSubtotal = this.getFlavorSubtotal();
      const isComplete = this.isCompleteSelection(flavorCount);
      const deviceRegularPrice = this.getDeviceRegularPrice();
      const flavorRegularSubtotal = this.getFlavorRegularSubtotal();
      const flavorSubtotal = this.getPreviewFlavorSubtotal(rawFlavorSubtotal, flavorCount, flavorRegularSubtotal);
      const total = devicePrice + flavorSubtotal;
      const regularTotalRaw = deviceRegularPrice + Math.max(rawFlavorSubtotal, flavorRegularSubtotal);
      const regularTotal = Math.max(total, regularTotalRaw);
      const totalSavings = Math.max(0, regularTotal - total);
      const hasDevice = !!this.selectedDeviceVariantId;
      const isFlavorLimitReached = hasDevice && this.isFlavorLimitReached();
      const deviceAvailable = this.getSelectedDeviceCard()?.dataset.available === 'true';
      const canSubmit = hasDevice && deviceAvailable && this.isValidFlavorCount(flavorCount) && !this.isSubmitting;

      if (!hasDevice) {
        this.setStepOpen(this.flavorStep, false);
      }
      if (this.flavorStep) {
        this.flavorStep.classList.toggle('is-locked', !hasDevice);
      }
      if (this.flavorStepSummary) {
        this.flavorStepSummary.setAttribute('aria-disabled', hasDevice ? 'false' : 'true');
      }

      this.deviceCards.forEach((card) => {
        const variantId = String(card.dataset.variantId || '');
        const isSelected = variantId === this.selectedDeviceVariantId;
        card.classList.toggle('is-selected', isSelected);

        const button = card.querySelector('[data-action="select-device"]');
        if (!button) return;
        button.disabled = card.dataset.available !== 'true';
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        if (button.disabled) {
          button.textContent = this.strings.soldOut || 'Sold out';
          return;
        }
        if (isSelected) {
          button.textContent = this.strings.selected || 'Selected';
          return;
        }
        const price = Number(card.dataset.price || 0);
        const delta = Math.max(0, price - this.baseDevicePrice);
        const deltaLabel = this.formatMoneyForDeviceButton(delta);
        const selectLabel = this.strings.select || 'Select';
        button.textContent = `${selectLabel} +${deltaLabel}`;
      });

      this.flavorCards.forEach((card) => {
        const variantId = String(card.dataset.variantId || '');
        const qty = Number(this.flavorQtyByVariantId[variantId] || 0);
        const selected = qty > 0;
        const lockedByFlavorLimit = isFlavorLimitReached && !selected;
        const controls = card.querySelector('[data-qty-controls]');
        const selectButton = card.querySelector('[data-action="select-flavor"]');
        const qtyCount = card.querySelector('[data-qty-count]');
        const qtyButtons = controls ? Array.from(controls.querySelectorAll('.build-pack__qty-button')) : [];

        card.classList.toggle('is-selected', selected);
        card.classList.toggle('is-disabled', !hasDevice || lockedByFlavorLimit);

        if (selectButton) {
          selectButton.disabled = !hasDevice || isFlavorLimitReached;
          selectButton.hidden = selected;
        }

        if (controls) {
          controls.hidden = !selected;
        }

        qtyButtons.forEach((button) => {
          const action = button.dataset.action;
          const isIncrease = action === 'increase-flavor';
          button.disabled = !hasDevice || (isIncrease && isFlavorLimitReached);
        });

        if (qtyCount) qtyCount.textContent = String(qty);
      });

      if (this.shouldUseFullPackMode(flavorCount)) {
        this.packMode = 'full';
      } else if (flavorCount >= 4) {
        this.packMode = '6';
      } else if (flavorCount >= 1) {
        this.packMode = '3';
      } else {
        this.packMode = '3';
      }
      this.renderPackOnly(flavorCount);

      if (this.customPackLabel) {
        const hasCompleteMode = this.getCompletePackCount() > 0;
        this.customPackLabel.hidden = !hasCompleteMode;
        this.customPackLabel.classList.toggle('is-active', isComplete);
        if (this.packToggle) {
          this.packToggle.classList.toggle('build-pack__pack-toggle--has-full', hasCompleteMode);
        }
      }

      if (this.stepDotDevice) {
        this.stepDotDevice.classList.toggle('is-complete', hasDevice);
      }
      if (this.stepDotFlavors) {
        this.stepDotFlavors.classList.toggle('is-complete', this.isValidFlavorCount(flavorCount));
      }

      if (this.summaryDevice) {
        const selectedDeviceCard = this.getSelectedDeviceCard();
        this.summaryDevice.textContent = selectedDeviceCard
          ? selectedDeviceCard.querySelector('.build-pack__device-title')?.textContent?.trim() || this.strings.selected
          : this.strings.noneSelected || 'None selected';
      }

      if (this.summaryFlavors) {
        const selectedTemplate = this.strings.selectedCountTemplate || '[count] selected';
        this.summaryFlavors.textContent = selectedTemplate.replace('[count]', String(flavorCount));
      }

      const fullCount = this.getCompletePackCount();
      const showComparePricing = totalSavings > 0;
      if (this.summaryPriceInline) this.summaryPriceInline.hidden = !hasDevice;
      if (this.summaryCompareTotal) this.summaryCompareTotal.hidden = !showComparePricing;
      if (this.summaryCompareTotal) this.summaryCompareTotal.textContent = this.formatMoney(regularTotal);
      if (this.summaryDiscountRow) this.summaryDiscountRow.hidden = true;
      if (this.summaryDiscount) this.summaryDiscount.textContent = '';
      if (this.summaryTotal) this.summaryTotal.textContent = this.formatMoney(total);

      if (this.submitButton) {
        let submitText = this.strings.addToCart || 'Add to cart';
        if (this.isSubmitting) {
          submitText = this.strings.adding || 'Adding...';
        } else if (!hasDevice) {
          submitText = this.strings.ctaSelectDevice || 'Select a device to continue';
        } else if (!deviceAvailable) {
          submitText = this.strings.soldOut || 'Sold out';
        } else if (!canSubmit) {
          const nextTarget = this.getNextThreshold(flavorCount, fullCount);
          if (nextTarget) {
            const remaining = Math.max(0, nextTarget - flavorCount);
            const addMoreTemplate = this.strings.ctaAddMoreTemplate || 'Add [count] more to continue';
            const addMoreText = addMoreTemplate.replace('[count]', String(remaining));
            const fraction = this.formatFraction(Math.min(flavorCount, nextTarget), nextTarget);
            submitText = `${addMoreText} (${fraction})`;
          }
        }

        this.submitButton.disabled = !canSubmit;
        this.submitButton.textContent = submitText;
      }

      this.updateSideHintPosition();
    }

    setError(message) {
      if (!this.errorNode) return;
      this.errorNode.hidden = !message;
      this.errorNode.textContent = message || '';
    }

    clearError() {
      this.setError('');
    }
  }

  function initSection(sectionRoot) {
    if (!sectionRoot || instances.has(sectionRoot)) return;
    instances.set(sectionRoot, new BuildYourPack(sectionRoot));
  }

  function initAll(context) {
    const scope = context || document;
    const sections = scope.querySelectorAll('[data-build-your-pack]');
    sections.forEach((root) => initSection(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
